import React, { useEffect } from "react";
import useApiRequest from "../../../../Hooks/apiReq";
import Iconroad from "../../../../assets/img/icon-road1.gif";
import UcrkIcon2 from "../../../../assets/img/ucrk-icon2.png";
const Rank = () => {
  const { error, loading, response, sendApiRequest } = useApiRequest();
  const dispatch = useDispatch();
  useEffect(() => {
    const user = sessionStorage.getItem("loggedInUser");
    if (!user) return;
    sendApiRequest(
      "POST",
      "/Dashboard/GetBussinessCommisionRankDetails",
      {
        action: "Rank",
      },
      {
        onSuccess: (res) => {
          dispatch(setRankDetails(res?.data));
        },
      }
    );
  }, []);
  const chartData = [
    {
      name: "Self Business",
      amount: Number(response?.selfBusinessAmount || 0),
    },
    {
      name: "Team Total",
      amount: Number(response?.teamTotalBusiness || 0),
    },
    {
      name: "Team Valid",
      amount: Number(response?.teamValidBusiness || 0),
    },
    {
      name: "Required",
      amount: Number(response?.requiredAmount || 0),
    },
    {
      name: "Target",
      amount: Number(response?.targetAmount || 0),
    },
  ];
  console.log("response", response);
  return (
    // <div className="col-12 col-xl-6">
    //   {loading && <SpinnerLoader />}
    //   <div className="card border">
    //     <div className="card-body p-2">
    //       <div className="row">
    //         <div className="col-lg-6">
    //           <h4 className="mt-2 fs-8">
    //             <span className="fas fa-chart-line"></span> Rank Details
    //           </h4>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="ucrk_detail-main">
    //       <RankCircle
    //         currentRank={response?.currentRank}
    //         nextRank={response?.nextRank}
    //         percentage={response?.maxLegPerc}
    //       />
    //       <div className="mt-4 w-100 overflow-x-auto">
    //         <div
    //           style={{
    //             width: "100%",
    //             height: "280px",
    //             padding: "16px",
    //           }}
    //         >
    //           <ResponsiveContainer width="98%" height="90%">
    //             <LineChart
    //               data={chartData}
    //               margin={{ top: 15, right: 10, left: -10, bottom: 0 }}
    //             >
    //               <defs>
    //                 <linearGradient id="lineGrad" x1="0" y1="0" x2="0" y2="1">
    //                   <stop offset="0%" stopColor="#a970ff" stopOpacity={0.8} />
    //                   <stop
    //                     offset="100%"
    //                     stopColor="#5c27fe"
    //                     stopOpacity={0.05}
    //                   />
    //                 </linearGradient>
    //               </defs>
    //               <CartesianGrid
    //                 strokeDasharray="4 4"
    //                 stroke="#d8d8d8"
    //                 opacity={0.25}
    //               />
    //               <XAxis
    //                 dataKey="name"
    //                 tick={{ fontSize: 11, fontWeight: 500 }}
    //                 tickMargin={8}
    //                 axisLine={false}
    //                 tickLine={false}
    //               />
    //               <YAxis
    //                 tick={{ fontSize: 11, fontWeight: 500 }}
    //                 axisLine={false}
    //                 tickLine={false}
    //               />
    //               <Tooltip
    //                 formatter={(v, name) => [convertToINRFormat(v), name]}
    //                 contentStyle={{
    //                   backgroundColor: "rgba(255, 255, 255, 0.96)",
    //                   borderRadius: "8px",
    //                   border: "1px solid #e0e0e0",
    //                   boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    //                   color: "#333", // Explicitly set base text color for light/dark stability
    //                 }}
    //               />
    //               <Line
    //                 type="monotone"
    //                 dataKey="amount"
    //                 stroke="#a970ff"
    //                 strokeWidth={3.2}
    //                 dot={{
    //                   r: 5,
    //                   fill: "#fff",
    //                   stroke: "#a970ff",
    //                   strokeWidth: 2,
    //                 }}
    //                 activeDot={{ r: 7 }}
    //               >
    //                 <LabelList
    //                   dataKey="amount"
    //                   position="bottom"
    //                   formatter={(value) => `₹${value.toLocaleString()}`}
    //                   style={{ fontSize: 12, fontWeight: 700 }}
    //                 />
    //               </Line>
    //             </LineChart>
    //           </ResponsiveContainer>
    //         </div>
    //       </div>
    //       <div className="d-flex justify-content-around text-center mb-3">
    //         <div>
    //           <span className="d-block text-blue-600 fs-8 fw-bold">
    //             {" "}
    //             {convertToINRFormat(response?.selfBusinessAmount)}
    //           </span>
    //           <small className="textColor">Self Business</small>
    //         </div>
    //         <div>
    //           <span className="d-block text-blue-600 fs-8 fw-bold">
    //             {" "}
    //             {convertToINRFormat(response?.teamTotalBusiness)}
    //           </span>
    //           <small className="textColor"> Team Total</small>
    //         </div>
    //         <div>
    //           <span className="d-block text-blue-600 fs-8 fw-bold">
    //             {" "}
    //             {convertToINRFormat(response?.teamValidBusiness)}
    //           </span>
    //           <small className="textColor"> Team Valid</small>
    //         </div>
    //         <div>
    //           <span className="d-block text-blue-600 fs-8 fw-bold">
    //             {convertToINRFormat(response?.requiredAmount)}
    //           </span>
    //           <small className="textColor"> Required Using SB/TB</small>
    //         </div>
    //         <div>
    //           <span className="d-block text-yellow-600 fs-8 fw-bold">
    //             {convertToINRFormat(response?.targetAmount)}
    //           </span>
    //           <small className="textColor">Target</small>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="col-12 col-xl-6  ">
      <div className="card border">
        <div className="card-body p-2">
          <div className="row">
            <div class="col-lg-3">
              <h4 className="mt-2 fs-8">
                <span className="fas fa-chart-line"></span>{" "}
                <FaChartLine size={22} /> Rank Details
              </h4>
            </div>
          </div>
        </div>
        <div className="ucrk_detail-main">
          <div className="ucrk-qualifier">
            <div class="ucb-left ">
              <b className="text-black">{response?.currentRank}</b>
              <small className="text-dark">Current Rank</small>
            </div>
            <div class="ucb-right">
              {/* <div>
                <b className="text-black">{response?.nextRank}</b>
              </div> */}
              <div className="next-rank-wrapper">
                <b className="text-black next-rank-text">
                  {response?.nextRank}
                </b>
              </div>

              <small className="text-dark">Next Rank</small>
            </div>
            <div class="progress-1">
              <div class="boy-icon">
                <img
                  style={{ marginLeft: Number(response?.maxLegPerc) + "%" }}
                  src={Iconroad}
                  alt=""
                />
              </div>
              <div class="progress">
                <div
                  class={response?.maxLegPerc ? "bar" : ""}
                  style={{ width: Number(response?.maxLegPerc) + "%" }}
                >
                  <p class="percent">{Number(response?.maxLegPerc || 0)}%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="ucrk-list">
            <b>Self Business</b>
            <span className="textColor">
              {convertToINRFormat(response?.selfBusinessAmount)}
            </span>
          </div>
          <div class="ucrk-team">
            <b className="textColor">
              Team Business Total{" "}
              <span className="textColor">
                {convertToINRFormat(response?.teamTotalBusiness)}
              </span>
            </b>
            <strong className="textColor">
              Valid{" "}
              <span className="textColor">
                {convertToINRFormat(response?.teamValidBusiness)}
              </span>
            </strong>
            <p>
              Maximum amount can consider from single team is:
              <span>
                {convertToINRFormat(response?.maxLegAmount)} (
                {Number(response?.maxLegPerc)} %)
              </span>
            </p>
          </div>
          <div class="ucrk-list">
            <b>Qualification For New Rank</b>
            <span class="green" style={{ color: "#c18824" }}>
              {convertToINRFormat(response?.targetAmount)}
            </span>
          </div>
          <div class="ucrk-using headingColor">
            Required More Business To Upgrade
          </div>
          <div class="ucrk-list">
            <b>Using Self Business</b>
            <span className="text-success">
              {convertToINRFormat(response?.requiredAmount)}
            </span>
          </div>
          <div class="ucrk-or">
            <img src={UcrkIcon2} alt="" />
          </div>
          <div class="ucrk-list">
            <b>Valid Team Business</b>
            <span className="text-success">
              {convertToINRFormat(response?.requiredAmount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(Rank);
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setRankDetails } from "../../../../Redux/Slices/profileSlice";
import {
  Area,
  CartesianGrid,
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { FaChartLine } from "react-icons/fa";

const RankCircle = ({ percentage = 0, currentRank, nextRank }) => {
  const radius = 60;
  const stroke = 10;
  const normalizedRadius = radius - stroke;
  const circumference = normalizedRadius * 2 * Math.PI;

  const [animatedPercent, setAnimatedPercent] = useState(0);
  const [offset, setOffset] = useState(circumference);

  // Animate % from 0 to final
  useEffect(() => {
    let start = 0;
    const duration = 800;
    const stepTime = 10;
    const increment = percentage / (duration / stepTime);

    const anim = setInterval(() => {
      start += increment;
      if (start >= percentage) {
        start = percentage;
        clearInterval(anim);
      }
      setAnimatedPercent(Math.round(start));
    }, stepTime);

    return () => clearInterval(anim);
  }, [percentage]);

  // Continuous animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => prev - 2);
    }, 20);

    return () => clearInterval(interval);
  }, []);

  const progressOffset =
    circumference - (animatedPercent / 100) * circumference;

  return (
    <div className="d-flex justify-content-center">
      <div
        style={{
          width: 150,
          height: 90,
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <svg width="150" height="150">
          {/* Background Circle */}
          <circle
            stroke="#e6e6e6"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="75"
            cy="75"
          />

          {/* Glowing Background Circle */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="75"
            cy="75"
            opacity="0.4"
            style={{
              filter: "blur(8px)",
            }}
            transform="rotate(-90 75 75)"
          />

          {/* Continuous rotating animation */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{
              transition: "stroke-dashoffset 0.2s linear",
              opacity: 0.3,
            }}
            r={normalizedRadius}
            cx="75"
            cy="75"
            transform="rotate(-90 75 75)"
          />

          {/* Actual % Progress */}
          <circle
            stroke="url(#grad)"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={progressOffset}
            style={{
              transition: "stroke-dashoffset 0.4s ease",
            }}
            r={normalizedRadius}
            cx="75"
            cy="75"
            transform="rotate(-90 75 75)"
          />

          <defs>
            <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#5c27fe" />
              <stop offset="100%" stopColor="#a970ff" />
            </linearGradient>
          </defs>
        </svg>

        {/* Text in Center */}
        <div style={{ position: "absolute", textAlign: "center" }}>
          <strong
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: "#a970ff",
            }}
          >
            {animatedPercent}%
          </strong>

          <p style={{ fontSize: 10, margin: 0, color: "#777" }}>
            Rank Progress
          </p>

          <p style={{ margin: 0, fontSize: 11 }}>
            <b>{currentRank}</b> → <b>{nextRank}</b>
          </p>
        </div>
      </div>
    </div>
  );
};
